export const SDK_SCRIPT_ID = 'postscript-sdk'
export const SDK_READY_TIMEOUT = 10000
export const SDK_POLL_INTERVAL = 100

export function sdkUrl(shopId) {
  return `https://sdk.postscript.io/sdk.bundle.js?shopId=${shopId}`
}

export function isSdkReady() {
  return !!(
    window.postscript &&
    window.postscript.popups &&
    typeof window.postscript.popups.open === 'function'
  )
}

export function loadPostscriptSdk(shopId) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(SDK_SCRIPT_ID)) {
      resolve()
      return
    }
    const src = sdkUrl(shopId)
    const script = document.createElement('script')
    script.id = SDK_SCRIPT_ID
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () =>
      reject(new Error(`PostscriptPopup: failed to load ${src}`))
    document.body.appendChild(script)
  })
}

// The SDK does not define window.postscript synchronously, so the script's
// onload is not a readiness signal — poll for the popups API until it appears
// or we give up.
export function waitForPostscriptSdk({
  timeout = SDK_READY_TIMEOUT,
  interval = SDK_POLL_INTERVAL
} = {}) {
  return new Promise((resolve, reject) => {
    const startedAt = Date.now()
    const check = () => {
      if (isSdkReady()) {
        resolve()
        return
      }
      if (Date.now() - startedAt >= timeout) {
        reject(
          new Error(
            'PostscriptPopup: SDK loaded but window.postscript.popups never became available.'
          )
        )
        return
      }
      setTimeout(check, interval)
    }
    check()
  })
}

export function openPostscriptPopup(popupId, options) {
  window.postscript.popups.open(popupId, options)
}
